import FocusMode from './FocusMode'
import Section from './Section'

import './style.scss'

export { FocusMode, Section }

export default Section
